import gql from 'graphql-tag';

const deleteFlatRateOfferBatchMutation = gql`
  mutation deleteFlatRateOfferBatch($input: DeleteFlatRateOfferBatchInput!) {
    deleteFlatRateOfferBatch(input: $input) {
      success
      errors
    }
  }
`;

export default deleteFlatRateOfferBatchMutation;
